import { render, staticRenderFns } from "./ProjectModalNew.vue?vue&type=template&id=c5504818&scoped=true"
import script from "./ProjectModalNew.vue?vue&type=script&lang=ts"
export * from "./ProjectModalNew.vue?vue&type=script&lang=ts"
import style0 from "./ProjectModalNew.vue?vue&type=style&index=0&id=c5504818&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5504818",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c5504818')) {
      api.createRecord('c5504818', component.options)
    } else {
      api.reload('c5504818', component.options)
    }
    module.hot.accept("./ProjectModalNew.vue?vue&type=template&id=c5504818&scoped=true", function () {
      api.rerender('c5504818', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/companyProjects/ProjectModalNew.vue"
export default component.exports